import {format} from "date-fns";


export const readFileAsBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const base64Data = reader.result?.toString()?.split(',')[1] ?? '';
            resolve(base64Data);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsDataURL(file);
    });
};


export const formatDateTime = (value?: string | Date): string => {
    if (!value) return '';

    const date = typeof value === 'string' ? new Date(value) : value;

    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    };

    return date.toLocaleString('cs-CZ', options);
};

export const formatDateTimeVariant = (
    value?: string | Date,
    variant: 'datetime' | 'date' | 'time' = 'datetime'
): string => {
    if (!value) return '';

    const date = typeof value === 'string' ? new Date(value) : value;

    let options: Intl.DateTimeFormatOptions;

    switch (variant) {
        case 'date':
            options = { day: '2-digit', month: '2-digit', year: 'numeric' };
            break;
        case 'time':
            options = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
            break;
        default:
            options = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            };
    }

    return date.toLocaleString('cs-CZ', options);
};


export const formatTime = (isoString?: string): string => {
    if (!isoString) return '';

    const date = new Date(isoString);
    const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    };
    return date.toLocaleString('cs-CZ', options);
};


export const convertDateToString = (date: Date | null | unknown): string => {
    if (!date) return "";
    const formattedDate = format(date as Date, "yyyy-MM-dd");
    return formattedDate;
};

/**
 * Validates that a URL is safe (uses http or https protocol).
 * Prevents XSS attacks via javascript: or data: URLs.
 */
export const isSafeUrl = (url: string | undefined | null): boolean => {
    if (!url) return false;
    try {
        const parsed = new URL(url);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
};

/**
 * Returns the URL if it's safe, otherwise returns undefined.
 */
export const getSafeUrl = (url: string | undefined | null): string | undefined => {
    return isSafeUrl(url) ? url! : undefined;
};

